import { render, staticRenderFns } from "./Buyer.vue?vue&type=template&id=63d4ef50&scoped=true"
import script from "./Buyer.vue?vue&type=script&lang=js"
export * from "./Buyer.vue?vue&type=script&lang=js"
import style0 from "./Buyer.vue?vue&type=style&index=0&id=63d4ef50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4ef50",
  null
  
)

export default component.exports